import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-dropdown-toggle"
}
const _hoisted_2 = { class: "as-dropdown-toggle__select" }
const _hoisted_3 = ["onClick"]

import { computed, ref } from "vue";
import { useClickOutside } from "~src/utils/clickOutsideHelper";
import IconCustomArrownDown from "~src/components/icons/IconCustomArrownDown.vue";
import IconCustomArrownUp from "~src/components/icons/IconCustomArrownUp.vue";

const __default__ = {};

interface IProps {
  data: any[];
  idActive?: string | number;
  isFilterAll?: boolean;
}
interface Item {
  id: number | string;
  title?: string;
  name?: string;
  year?: string;
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'DropdownToggle',
  props: {
    data: {},
    idActive: {},
    isFilterAll: { type: Boolean }
  },
  emits: ["handleChoose"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;
const selectHeader = ref<HTMLElement | null>(null);
const selectContent = ref<HTMLElement | null>(null);
const itemActive = ref<Item | null>(
  props.idActive
    ? props.data.find((item: any) => item.id === props.idActive)
    : null
);
const isShow = ref(false);

const dataFilterAll = computed(() => {
  if (props.isFilterAll) {
    return [{ id: "", name: "Tất cả" }, ...props.data];
  }

  return props.data;
});

const handleToggle = () => {
  isShow.value = !isShow.value;
};
const handleChoose = (item: Item) => {
  itemActive.value = item;
  isShow.value = false;

  emits("handleChoose", item);
};

const closeCountrySelect = () => {
  isShow.value = false;
};

useClickOutside([selectHeader, selectContent], {
  handler: closeCountrySelect,
  middleware: (event) => {
    const target = event.target as HTMLElement;

    if (target.closest(".icon-arrow")) {
      return false;
    }

    return true;
  },
});

return (_ctx: any,_cache: any) => {
  return (dataFilterAll.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "as-dropdown-toggle__select__as-head",
            onClick: handleToggle,
            ref_key: "selectHeader",
            ref: selectHeader
          }, [
            _createElementVNode("span", null, _toDisplayString(itemActive.value && itemActive.value?.id
            ? itemActive.value.name ?? itemActive.value.year ?? itemActive.value.title
            : "Tất cả"), 1),
            (!isShow.value)
              ? (_openBlock(), _createBlock(IconCustomArrownDown, {
                  key: 0,
                  fill: "#2FB925",
                  onClick: _withModifiers(handleToggle, ["stop"])
                }))
              : (_openBlock(), _createBlock(IconCustomArrownUp, {
                  key: 1,
                  fill: "#2FB925",
                  onClick: _withModifiers(handleToggle, ["stop"])
                }))
          ], 512),
          (isShow.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "as-dropdown-toggle__select__as-body",
                ref_key: "selectContent",
                ref: selectContent
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataFilterAll.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(["as-item-dropdown", {
            'as-active': _ctx.idActive === item.id
          }]),
                    onClick: ($event: any) => (handleChoose(item))
                  }, _toDisplayString(item.name ?? item.year ?? item.title), 11, _hoisted_3))
                }), 128))
              ], 512))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})